import { Injectable } from '@angular/core';
import { ApiService } from './api.service';

@Injectable({
  providedIn: 'root',
})
export class QBService {
  constructor(private _api: ApiService) {}

  getSettings = () => {
    return this._api.get('qbdata/settings');
  };
  getSyncWorkerEnabled = () => {
    return this._api.get<boolean>('qbdata/syncworkerenabled');
  };
  saveSettings = (s: any) => {
    return this._api.post('qbdata/settings', s);
  };
  disconnectFromQB = () => {
    return this._api.post('qbdata/disconnect');
  };
  getPaymentSettings = () => {
    return this._api.get('qbdata/paymentsettings');
  };
  savePaymentSettings = (s: any) => {
    return this._api.post('qbdata/paymentsettings', s);
  };
  getTestData = () => {
    return this._api.get('qbdata/testdata');
  };
  getCostcodeMatching = () => {
    return this._api.get('qbdata/costcodematching');
  };
  setCostcodeMatching = (costcodes: any) => {
    return this._api.post('qbdata/costcodematching', costcodes);
  };
  getStaffMatching = () => {
    return this._api.get('qbdata/staffmatching');
  };
  setStaffMatching = (staff: any) => {
    return this._api.post('qbdata/staffmatching', staff);
  };
  getJobMatching = () => {
    return this._api.get('qbdata/jobmatching');
  };
  setJobMatching = (jobs: any) => {
    return this._api.post('qbdata/jobmatching', jobs);
  };
  getLMNEmployees = () => {
    return this._api.get('qbdata/lmnemployees');
  };
  getRangeEmployees = (startdate: any, weeks: any) => {
    return this._api.post('qbdata/rangeemployees', {
      StartDate: startdate,
      Weeks: weeks,
    });
  };
  getRangeJobs = (startdate: any, weeks: any, employees: any) => {
    return this._api.post('qbdata/rangejobs', {
      StartDate: startdate,
      Weeks: weeks,
      Employees: employees,
    });
  };
  requestPublish = (
    startdate: any,
    weeks: any,
    employees: any,
    deleteexisting: any,
  ) => {
    return this._api.post('qbdata/publishrequest', {
      StartDate: startdate,
      Weeks: weeks,
      Employees: employees,
      DeleteExisting: deleteexisting,
      TimezoneOffset: new Date().getTimezoneOffset(),
    });
  };
  requestEstimatesPublish = (standard: any, service: any) => {
    return this._api.post('qbdata/publishestimatesrequest', {
      StandardEstimates: standard,
      ServiceEstimates: service,
      TimezoneOffset: new Date().getTimezoneOffset(),
    });
  };
  requestInvoicesPublish = (invoices: any) => {
    return this._api.post('qbdata/publishinvoicesrequest', {
      Invoices: invoices,
      TimezoneOffset: new Date().getTimezoneOffset(),
    });
  };
  requestPaymentsPublish = (payments: any) => {
    return this._api.post('qbdata/publishpaymentsrequest', {
      Payments: payments,
      TimezoneOffset: new Date().getTimezoneOffset(),
    });
  };
  getQueuedRequests = () => {
    return this._api.get('queuedrequests');
  };
  createQBOJob = (obj: any) => {
    return this._api.post('qbdata/createjob', obj);
  };
  createQBOEmployee = (itemID: any) => {
    return this._api.post('qbdata/createemployee', { ItemID: itemID });
  };
  createQBOItem = (itemID: any) => {
    return this._api.post('qbdata/createitem', { ItemID: itemID });
  };
  getClassMatching = () => {
    return this._api.get('qbdata/classmatching');
  };
  setClassMatching = (costcodes: any) => {
    return this._api.post('qbdata/classmatching', costcodes);
  };
  getTaxMatching = () => {
    return this._api.get('qbdata/taxmatching');
  };
  setTaxMatching = (taxgroups: any) => {
    return this._api.post('qbdata/taxmatching', taxgroups);
  };
  getQueuedEstimates = () => {
    return this._api.get('qbdata/queuedestimates');
  };
  getQueuedInvoices = () => {
    return this._api.get('qbdata/queuedinvoices');
  };
  getQueuedPayments = () => {
    return this._api.get('qbdata/queuedpayments');
  };
  getPaymentMethodMatching = () => {
    return this._api.get('qbdata/paymentmethodmatching');
  };
  setPaymentMethodMatching = (paymethods: any) => {
    return this._api.post('qbdata/paymentmethodmatching', paymethods);
  };
  requestCustomerImport = (option: any) => {
    return this._api.post('qbdata/importcustomersrequest', {
      InactiveOption: option,
      TimezoneOffset: new Date().getTimezoneOffset(),
    });
  };
  requestVendorsImport = (option: any) => {
    return this._api.post('qbdata/vendors/import', {
      InactiveOption: option,
      TimezoneOffset: new Date().getTimezoneOffset(),
    });
  };
  getVendors = () => {
    return this._api.get('qbdata/vendors');
  };
  createQBVendor = (lmnVendor: any) => {
    return this._api.post('qbdata/vendors/quickbooks', lmnVendor);
  };
  saveVendors = (lmnVendors: any) => {
    return this._api.put('qbdata/vendors', { Vendors: lmnVendors });
  };
  getVendorBills = () => {
    return this._api.get('qbdata/vendorbills/queued');
  };
  requestVendorBillsPublish = (vendorBills: any) => {
    return this._api.post('qbdata/vendorbills', {
      VendorBills: vendorBills,
      TimezoneOffset: new Date().getTimezoneOffset(),
    });
  };
}
